import { useMemo, useState } from 'react';

const EMOJI_CATEGORIES = {
  Smileys: ['😀','😁','😂','🤣','😃','😄','😅','😆','😉','😊','😋','😎','😍','😘','🥰','😗','😙','😚','🙂','🤗','🤩','🤔','🫡','😐','😑','😶','🙄','😏','😣','😥','😮','🤐','😯','😪','😫','🥱','😴','😌','😛','😜','🤪','😝','🫠','🤤','😒','😓','😔','😕','🙃','🤑','😲','☹️','🙁','😖','😞','😟','😤','😢','😭','😦','😧','😨','😩','😬','😰','😱','🥵','🥶','😳','🤯','😵','🥴','😡','😠','🤬','😷','🤒','🤕','🤢','🤮','🤧'],
  Gestures: ['👍','👎','👌','🤌','🤏','✌️','🤞','🫶','🤟','🤘','🤙','👈','👉','👆','👇','☝️','✋','🤚','🖐️','🖖','👋','🤝','🙏','💪','🫵','👏','🙌','👐','🤲','🙇','💁','🙆','🙅','🤦','🤷','🧠','❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','🔥','💯','✅','❌','⚠️','🚨','📢'],
  Nature: ['🌍','🌎','🌏','🌤️','⛅','🌥️','🌦️','🌧️','⛈️','🌩️','🌨️','☀️','🌙','⭐','🌟','✨','⚡','💧','🌊','🌴','🌵','🌿','🍀','🍁','🍂','🍃','🌺','🌸','🌼','🌻','🌹','🌷','🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯','🦁','🐮','🐷','🐸','🐵','🦄','🐔','🐧','🐦','🦅','🦉','🐺','🐗','🐴','🦋','🐝','🐛'],
  Food: ['🍎','🍏','🍊','🍋','🍌','🍉','🍇','🍓','🫐','🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🍆','🥑','🥦','🥬','🥒','🌶️','🫑','🌽','🥕','🫒','🧄','🧅','🥔','🍠','🥐','🍞','🥖','🥨','🧀','🥚','🍳','🥞','🧇','🥓','🍗','🍖','🌭','🍔','🍟','🍕','🥪','🌮','🌯','🥗','🍝','🍜','🍣','🍱','🍛','🍚','🍰','🧁','🍩','🍪','🍫','🍿','☕','🧋','🥤','🍺'],
  Objects: ['📱','💻','⌚','📷','📹','🎥','🎬','📺','📻','🎧','🎤','🎙️','🎚️','🎛️','🕹️','💡','🔦','📚','📖','📰','🗞️','📌','✏️','🖊️','🖋️','🖌️','📝','💼','👜','🎒','🧳','🔒','🔓','🧷','🧹','🧪','🧫','🧬','💊','🩹','🧯','🛒','⚙️','🔧','🔨','🪛','🧰','🪜','🧲','🪙','💎','🗑️'],
  Travel: ['🚗','🚕','🚙','🚌','🚎','🏎️','🚓','🚑','🚒','🚚','🚛','🚜','🛵','🏍️','🚲','🛴','🚨','🚔','🚘','🚖','🚆','🚇','🚊','🚉','✈️','🛫','🛬','🚀','🛸','🚁','⛵','🚤','🛳️','⚓','⛽','🗺️','🧭','🏕️','🏖️','🏜️','🏝️','🏞️','🏙️','🌆','🌃','🌉','🌁','🎡','🎢','🎠'],
};

export default function EmojiPicker({ onSelect, disabled = false }) {
  const [open, setOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState('Smileys');
  const [search, setSearch] = useState('');

  const visible = useMemo(() => {
    const term = search.trim();
    if (!term) return EMOJI_CATEGORIES[activeCategory] || [];
    const all = Object.values(EMOJI_CATEGORIES).flat();
    return all.filter((emoji) => emoji.includes(term));
  }, [activeCategory, search]);

  return (
    <div className="emoji-picker-wrap">
      <button
        type="button"
        className="btn-ghost btn-sm"
        onClick={() => setOpen((v) => !v)}
        disabled={disabled}
      >
        😀 Emoji Pack
      </button>

      {open && (
        <div className="emoji-picker-panel" role="dialog" aria-label="Emoji picker">
          <input
            className="form-input emoji-search"
            placeholder="Search emoji (example: 😀)"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            disabled={disabled}
          />

          <div className="emoji-categories">
            {Object.keys(EMOJI_CATEGORIES).map((name) => (
              <button
                key={name}
                type="button"
                className={`emoji-category-btn ${activeCategory === name ? 'tab-active' : ''}`}
                onClick={() => {
                  setSearch('');
                  setActiveCategory(name);
                }}
                disabled={disabled}
              >
                {name}
              </button>
            ))}
          </div>

          <div className="emoji-grid">
            {visible.map((emoji, idx) => (
              <button
                key={`${emoji}-${idx}`}
                type="button"
                className="emoji-btn"
                onClick={() => onSelect(emoji)}
                disabled={disabled}
                title={emoji}
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
